import jetbrains from './jetbrains/all';

export default function () {
    //Run jetbrains Apis
    jetbrains();
}